<script setup lang="ts">
  import { MessagePlusSquareIcon } from '@gohighlevel/ghl-icons/24/outline'

  import CPFAB from '@ui/components/CPFAB.vue'

  const emit = defineEmits<{
    click: []
  }>()

  defineOptions({
    name: 'NewChatFAB',
  })

  const { t } = useI18n()

  const handleClick = () => {
    emit('click')
  }
</script>

<template>
  <CPFAB :icon="MessagePlusSquareIcon" :label="t('chats.newChat.fabLabel')" variant="light" size="md" @click="handleClick" />
</template>
